import React from 'react'; // 导入 useState Hook
import { useConfig } from 'context/ConfigContext.js';


const EarnCredits = () => {
  const config = useConfig();
  if (!config) return null; // Guard clause

  const { appName } = config;

  return (
      <section className="py-16 px-4 bg-sky-50">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-sky-700">
            Easily Earn Free Call Credits
          </h2>
          <p className="text-lg text-gray-700 mb-10 max-w-2xl mx-auto">
            Get free call credits through various methods to keep your conversations going.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Credit Method 1 */}
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-4xl text-yellow-500 mb-3">🎬</div>
              <h3 className="text-lg font-semibold mb-2">Watch Videos</h3>
              <p className="text-gray-600">Earn call credits by watching short videos.</p>
            </div>
            {/* Credit Method 2 */}
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-4xl text-red-500 mb-3">✅</div>
              <h3 className="text-lg font-semibold mb-2">Complete Tasks</h3>
              <p className="text-gray-600">Participate in in-app tasks to earn generous credit rewards.</p>
            </div>
            {/* Credit Method 3 */}
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-4xl text-green-500 mb-3">🤝</div>
              <h3 className="text-xl font-semibold mb-2">Invite Friends</h3>
              <p className="text-gray-600">Invite friends to {appName}, and both you and your friends will receive rewards.</p>
            </div>
          </div>
        </div>
      </section>
  );
};

export default EarnCredits;